@if (form(); as formGroup) {
  <form class="flex w-full flex-col gap-8" [formGroup]="formGroup">
    <div>
      <h2 class="!font-medium">Fitness for Work</h2>
      <p class="font-bold">Is the patient fit to continue normal work? *</p>
      <mat-radio-group
        class="mb-2 flex flex-col"
        formControlName="canResumeNormalWork"
        required
      >
        @for (option of booleanOptions; track option.code) {
          <mat-radio-button class="mr-4" [value]="option.label">
            {{ booleanDisplay[option.code] }}
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (formGroup.canResumeNormalWorkRequiredError) {
        <mat-error>This field is required</mat-error>
      }
    </div>

    @if (formGroup.displayIncapacity) {
      <div>
        <p class="font-bold">Incapacity Details</p>

        <div class="mb-4 flex flex-col gap-4" formArrayName="incapacity">
          @for (
            control of formGroup.incapacityControls;
            track idx;
            let idx = $index
          ) {
            <div
              class="flex flex-col gap-4 rounded bg-gray-50 p-4"
              [formGroupName]="idx"
            >
              @if (idx > 0) {
                <div class="flex justify-end">
                  <button
                    mat-stroked-button
                    color="warn"
                    [disabled]="disabled()"
                    (click)="formGroup.removeIncapacityForm($event, idx)"
                  >
                    Remove
                  </button>
                </div>
              }

              <mat-form-field class="w-full">
                <mat-label>Incapacity Type</mat-label>
                <mat-select formControlName="incapacityType" required>
                  @for (option of incapacityTypeOptions; track option.code) {
                    <mat-option [value]="option.label">
                      {{ option.code | splitCamel }}
                    </mat-option>
                  }
                </mat-select>
                @if (control.incapacityTypeRequiredError) {
                  <mat-error>This field is required</mat-error>
                }
              </mat-form-field>

              @if (control.displaySelectedAlternativeWork) {
                <div
                  class="flex flex-col gap-4"
                  formGroupName="selectedAlternativeWork"
                >
                  <mat-form-field class="w-full">
                    <mat-label>Alternative Work Type</mat-label>
                    <mat-select formControlName="alternativeWorkTypeCode">
                      @for (option of workTypeOptions; track option.code) {
                        <mat-option [value]="option.code">{{
                          option.label
                        }}</mat-option>
                      }
                    </mat-select>
                    @if (
                      control.selectedAlternativeWorkGroup
                        .alternativeWorkTypeCodeRequiredError
                    ) {
                      <mat-error>This field is required</mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field class="w-full">
                    <mat-label>Physical Restrictions</mat-label>
                    <mat-select formControlName="physicalRestrictions" multiple>
                      @for (
                        option of physicalRestrictionOptions;
                        track option.code
                      ) {
                        <mat-option [value]="option.label">
                          {{ option.code | splitCamel }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field class="w-full">
                    <mat-label>Restricted Hours Per Day</mat-label>
                    <input
                      matInput
                      type="number"
                      min="1"
                      max="24"
                      formControlName="restrictedHoursPerDay"
                      placeholder="Enter hours (1-24)"
                    />
                    <mat-hint>Enter hours (1-24)</mat-hint>
                    @if (
                      control.selectedAlternativeWorkGroup
                        .restrictedHoursPerDayRequiredError
                    ) {
                      <mat-error>This field is required</mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field class="w-full">
                    <mat-label>Restriction Comment</mat-label>
                    <textarea
                      matInput
                      formControlName="restrictionComment"
                      rows="3"
                    ></textarea>
                    <mat-hint>
                      Optional - provide any additional details about the
                      restrictions
                    </mat-hint>
                  </mat-form-field>
                </div>
              }

              <div class="mb-4">
                <pt-date-range-form
                  dateLabel="Enter Incapacity Date Range"
                  [useRangePicker]="true"
                  [disabled]="disabled()"
                  [from]="from"
                  [to]="to"
                  (changed)="control.updateIncapacityDateRange($event)"
                />
                @if (control.incapacityDateRangeRequiredError) {
                  <span class="mt-2 text-xs text-red-500">
                    This field is required
                  </span>
                }
              </div>
            </div>
          }

          <div class="flex justify-end">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              [disabled]="disabled()"
              (click)="formGroup.addIncapacityForm($event)"
            >
              <mat-icon>add</mat-icon>
              Add Incapacity Period
            </button>
          </div>
        </div>

        <pt-iso-date-selector
          class="w-full"
          placeholder="Date for returning to normal work"
          formControlName="returnToNormalWorkDate"
        />
      </div>
    }
  </form>
}
